import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import { GHG_ESTIMATOR_CONCEPT_ID } from '~/constants/concepts'


export default /*#__PURE__*/_defineComponent({
  __name: 'GhgResultTable',
  props: {
    impactData: { default: undefined },
    impactGoalData: { default: undefined },
    impactSolutionData: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { impactData: Record<string, any>, impactGoalData: Record<string, any>, impactSolutionData: Record<string, any> };



const route = useRoute()
const ventureId = computed(() => route.params.venture)

const resultReferencePeriods = computed<number[] | null>(() => {
  const impacts = ((props.impactGoalData as any)?.impacts ?? []) as Array<any>
  const ghgImpact = impacts.find(
    (impact) => Number(impact?.conceptId) === GHG_ESTIMATOR_CONCEPT_ID,
  )
  const start = Number(ghgImpact?.startingYear ?? (props.impactGoalData as any)?.ghgStartingYear)
  if (!Number.isFinite(start)) return null
  return Array.from({ length: 5 }, (_, i) => start + i)
})

return { __sfc: true,props, route, ventureId, resultReferencePeriods }
}

})